import { render } from "./MatchCard.vue?vue&type=template&id=d5384568&scoped=true&lang=true"
import script from "./MatchCard.vue?vue&type=script&lang=js"
export * from "./MatchCard.vue?vue&type=script&lang=js"

import "./MatchCard.vue?vue&type=style&index=0&id=d5384568&lang=scss&scoped=true"

import exportComponent from "/var/lib/buildkite-agent/builds/BKxAWS-i-0a0cda5bfc5ca6053-1/assemble-sports/universityoftasmania-livescores-production-vertical-traffic-light/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5384568"]])

export default __exports__